exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".interactive-survey-message-additional-data-ok-button{height:50px;width:50px;border-radius:50px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/interactiveSurvey/styles/additionalData.scss
// module id = 1161
// module chunks = 0 1